































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateFormat from '@/shared/utils/date-format';
import EventBus, { Event } from '@/event.bus'
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import BusinessUnitMacro from '@/components/business-unit/business-unit-macro.component.vue';
import Pagination from '@/domain/pagination.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import RuleService from '@/domain/rule/service/rule.service';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import UserProfile from '@/domain/access/domain/profile.enum';
import Rule from '@/domain/rule/entity/rule.entity';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import ProductTemplate from '@/domain/product-template/entity/product-template.entity';
import ProductTemplateRule from '@/domain/product-template/entity/product-template-rule.entity';
import FilterProductTemplate from '@/domain/product-template/service/filter-product-template.entity';
import ProductTemplateRuleRequest from '@/domain/product-template/entity/product-template-rule-request.entity';
import ProductTemplateService from '@/domain/product-template/service/product-template.service';
import ProductTemplateCalculationModal from '@/views/product-template/product-template-calculation-modal.vue';
import SelectDataSourceModal from '@/views/contract/contract-info/itens/datasource/select-datasource-modal.component.vue';
import ProductTemplateDuplicateModal from '@/views/product-template/product-template-duplicate-modal.vue';
import ProductTemplateFilter from './product-template-filter.component.vue';
import Header from './header.json';

@Component({
  components: {
    ProductTemplateFilter,
    VbPagination,
    VbTooltipSlot,
    BusinessUnitMacro,
    ProductTemplateCalculationModal,
    SelectDataSourceModal,
    ModalWarning,
    ProductTemplateDuplicateModal,
  },
  filters: {
    formatDateTime(value: string) {
      if (!value) return '';
      return DateFormat.fullDateAndTime(value);
    },
    truncate(value: string, length: number) {
      if (!value) return '';
      return value.length > length ? `${value.substring(0, length)}...` : value;
    },
  },
})

export default class ProductTemplateDatatable extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  showMacroModal: boolean = false;

  modalExternalTitleDefault: string = 'Macro de Padrões de Produto Template';

  modalExternalTitle: string = '';

  showFilter: boolean = false;

  searching: boolean = false;

  loading: boolean = false;

  filter: FilterProductTemplate = new FilterProductTemplate({});

  macroSaving: boolean = false;

  updateMacroId: string = '';

  updateMacroProductId: number = 0;

  updateMacroDescription: string = '';

  updateMacroObservation: string = '';

  productTemplateHeaders = Header;

  productTemplateList = [] as ProductTemplate[];

  productTemplateSelected: ProductTemplate = new ProductTemplate();

  productTemplateRule: ProductTemplateRule = ProductTemplateRule.of({});

  showModalRule: boolean = false;

  editModeValue: boolean = false;

  showModalDataSource: boolean = false;

  showModalDuplicate: boolean = false;

  datasources: Datasource[] = [];

  businessUnits: BusinessUnit[] = [];

  isAdministrator: boolean = false;

  profile: string = '';

  restrictRulesProfile: Rule[] = [];

  loadingPersistRule: boolean = false;

  datasourceSelectionKey: number = 0;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'description|asc',
  });

  get isAdministratorOrSupervisor(): boolean {
    return this.isAdministrator || this.profile === UserProfile.SUPERVISOR;
  }

  getRestrictRulesPerProfile() {
    RuleService.getRestrictRulesPerProfile(this.businessUnitId, this.profile)
      .then((response: Rule[]) => this.restrictRulesProfile = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  colorCalculator(item: ProductTemplate): string {
    return item.hasCalculationRules ? 'primary' : 'redPrimary';
  }

  warningModalValue: boolean = false;

  warningMessage: string = '';

  deleteProductTemplateId: string = '';

  editObservation(item: ProductTemplate) {
    this.updateModalExternalTitle(`Editar Macro Padrão de Produto: ${item.description}`);
    this.showMacroModal = true;
    this.updateMacroId = item.id ?? '';
    this.updateMacroProductId = item.productId ?? null;
    this.updateMacroDescription = item.description ?? '';
    this.updateMacroObservation = item.observation ?? '';
  }

  handleWarningModal(item: ProductTemplate, action: string) {
    this.warningModalValue = true;
    this.deleteProductTemplateId = item.id ?? '';
    this.warningMessage = `Deseja realmente prosseguir? Ao clicar no botão Sim, o item '${item.description}' será removida.`
  }

  handleCancelModalRule() {
    this.showModalRule = false;
    this.resetContractItemRuleObject();
  }

  handleCancelModalDataSource() {
    this.showModalDataSource = false;
    this.productTemplateSelected = new ProductTemplate();
    this.datasourceSelectionKey += 1;
  }

  handleCancelModalDuplicate() {
    this.showModalDuplicate = false;
    this.productTemplateSelected = new ProductTemplate();
  }

  preview(id: string) {
    this.$router.push({ name: 'ProductTemplatePreview', params: { id } });
  }

  updateTable() {
    this.pagination.verifyPage();
    this.getAllProductTemplate(this.filter);
  }

  updateModalExternalTitle(title: string): void {
    this.modalExternalTitle = title.trim().length > 0
      ? title
      : this.modalExternalTitleDefault;
  }

  resetUpdateMacroData() {
    this.macroSaving = false;
    this.updateMacroId = '';
    this.updateMacroProductId = 0;
    this.updateMacroDescription = '';
    this.updateMacroObservation = '';
  }

  async updateMacro(macro: string) {
    if (this.macroSaving) return;
    this.macroSaving = true;

    if (this.updateMacroId.trim().length === 0) {
      const params = {
        productId: this.updateMacroProductId,
        description: this.updateMacroDescription ?? '',
      };
      try {
        const productTemplate = await ProductTemplateService
          .createProductTemplate(this.businessUnitId, params)
        this.updateMacroId = productTemplate.id ?? '';
      } catch (error) {
        VbSnackbarService.handleHttpError(error);
        this.resetUpdateMacroData();
        return;
      }
    }

    if (this.updateMacroId.trim().length === 0) {
      VbSnackbarService.showError('ID do produto template não pode ser vazio.');
      this.resetUpdateMacroData();
      return;
    }

    ProductTemplateService.updateProductTemplateObservation(
      this.businessUnitId,
      this.updateMacroId,
      macro,
    )
      .then(() => {
        this.showMacroModal = false;
        this.getAllProductTemplate(this.filter);
      })
      .catch((err) => VbSnackbarService.handleHttpError(err))
      .finally(() => this.resetUpdateMacroData());
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  applyFilter(filter: FilterProductTemplate) {
    this.filter = filter;
    this.updateTable();
  }

  getAllProductTemplate(filter: FilterProductTemplate) {
    if (this.searching) return;

    this.searching = true;
    this.loading = true;
    ProductTemplateService.getAll(this.businessUnitId, filter, this.pagination)
      .then((response) => {
        this.productTemplateList = ProductTemplate.ofList(response.content);
        this.pagination.total = response.totalElements;
        this.pagination.pageCount = response.totalPages;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.searching = false;
        this.loading = false;
      });
  }

  deleteProductTemplate(): void {
    if (!this.deleteProductTemplateId) {
      VbSnackbarService.handleHttpError('ID do produto template não pode ser vazio.');
      return;
    }
    ProductTemplateService.deleteProductTemplate(this.deleteProductTemplateId)
      .then(() => {
        this.getAllProductTemplate(this.filter);
        VbSnackbarService.showSuccess('Produto Template removido com sucesso');
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.deleteProductTemplateId = '';
        this.warningMessage = '';
        this.updateWarningModalState(false);
      });
  }

  updateWarningModalState(value: boolean): void {
    this.warningModalValue = value;
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.profile = UserBusinessUnitService.currentBusinessUnit.profile;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
        this.profile = businessUnit.profile;
        this.pagination.page = 1
        this.getAllProductTemplate(this.filter);
        this.getBusinessUnits();
        this.getDatasources();
      }
    })
    this.getAllProductTemplate(this.filter);
    this.getBusinessUnits();
    this.getDatasources();
    this.getRestrictRulesPerProfile();
  }

  getDatasources() {
    if (this.businessUnitId) {
      BusinessUnitService.getDatasources(this.businessUnitId)
        .then((resp: any) => this.datasources = resp)
    }
  }

  getBusinessUnits() {
    BusinessUnitService.getAll()
      .then((response: any) => {
        this.businessUnits = response.filter(
          (unit: BusinessUnit) => unit.id !== this.businessUnitId,
        );
      })
  }

  handleCancelEdit() {
    this.editModeValue = false;
    this.resetContractItemRuleObject();
    this.getProductTemplateRule(this.productTemplateSelected);
  }

  resetContractItemRuleObject() {
    this.productTemplateRule = ProductTemplateRule.of({});
  }

  getProductTemplateRule(item: ProductTemplate) {
    this.productTemplateSelected = item;
    this.showModalRule = true;
    if (item.id) {
      ProductTemplateService.getRules(item.id)
        .then((response: ProductTemplateRule) => {
          this.productTemplateRule = response;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  handleModalDataSource(item: ProductTemplate) {
    this.productTemplateSelected = item;
    this.showModalDataSource = true;
  }

  handleModalDuplicate(item: ProductTemplate) {
    this.productTemplateSelected = item;
    this.showModalDuplicate = true;
  }

  checkProductTemplate(productTemplateRule: ProductTemplateRule) {
    this.loadingPersistRule = true;
    this.productTemplateRule = productTemplateRule;
    if (!this.productTemplateSelected.id) {
      ProductTemplateService.createProductTemplate(this.businessUnitId,
        this.productTemplateSelected)
        .then((response: any) => {
          this.productTemplateSelected.id = response.id;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
    this.persistProductTemplateRule();
  }

  persistProductTemplateRule() {
    if (this.productTemplateSelected.id) {
      const productTemplateRules = ProductTemplateRuleRequest.ofList(
        this.productTemplateRule.rules,
      );
      ProductTemplateService.createProductTemplateRule(this.businessUnitId,
        this.productTemplateSelected.id, productTemplateRules)
        .then(() => {
          VbSnackbarService.showSuccess('Regra salva com sucesso!');
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => {
          this.loadingPersistRule = false;
          this.handleCancelEdit();
          this.productTemplateSelected = new ProductTemplate();
          this.getAllProductTemplate(this.filter);
        });
    }
  }
}
